import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import generateMenu from 'stores/business/protocolExplorerMenuBusiness/protocolMenuGenerator';
import {ExplorerHeaderProtocolMenu} from 'constants/protocolExplorerEnum';
import {getSelectedProtocolAndFolderIds} from 'stores/selectors/protocolExplorerSelectors';
import {FmlxMenu} from 'fmlx-common-ui';
import MenuIcon from '../../components/MenuIcon/MenuIcon';

function ProtocolExplorerMenuHeader({menuList, menuLabel, menuIcon, dropDownIcon, hidden}) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const selectedItemIds = useSelector(getSelectedProtocolAndFolderIds);
  const [updatedMenuList, setUpdatedMenuList] = useState(menuList);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = async () => {
    setAnchorEl(null);
  };

  const getInjectedCloseHandler = useCallback(() => {
    const generatedMenu = dispatch(generateMenu(ExplorerHeaderProtocolMenu, selectedItemIds));

    // temporary, until every menu get refactored
    const allMenuList = [...generatedMenu, ...menuList];
    const menuWithInjectedCloseHandler = allMenuList.map((menu) => {
      if (menu?.onClick && typeof menu?.onClick === 'function') {
        return {
          ...menu,
          onClick: () => {
            handleClose(); // close popover first
            menu.onClick();
          },
        };
      }
      return menu;
    });

    return menuWithInjectedCloseHandler;
  }, [dispatch, menuList, selectedItemIds]);

  useEffect(() => {
    if (!anchorEl) {
      return;
    }

    const updatedMenu = getInjectedCloseHandler();
    setUpdatedMenuList(updatedMenu);
  }, [anchorEl, getInjectedCloseHandler]);

  return hidden ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <></>
  ) : (
    <>
      <MenuIcon icon={menuIcon} label={menuLabel} onClick={handleClick} dropDownIcon={dropDownIcon} />
      <FmlxMenu
        onClose={handleClose}
        open={Boolean(anchorEl)}
        listItem={updatedMenuList}
        anchorEl={anchorEl}
        anchorReference="anchorEl"
        isOverlay
      />
    </>
  );
}

ProtocolExplorerMenuHeader.propTypes = {
  menuList: PropTypes.arrayOf(PropTypes.object),
  menuIcon: PropTypes.string,
  menuLabel: PropTypes.string,
  dropDownIcon: PropTypes.bool,
  hidden: PropTypes.bool,
};
ProtocolExplorerMenuHeader.defaultProps = {
  menuList: [],
  menuLabel: '',
  menuIcon: '',
  dropDownIcon: true,
  hidden: false,
};

export default ProtocolExplorerMenuHeader;
